// extracted by mini-css-extract-plugin
export default {"page":"MGPage_page__pV0uJ","mobileViewport":"MGPage_mobileViewport__M4-Um","body":"MGPage_body__e0AB1","content":"MGPage_content__hHtlh"};